<template>
    <div>
        <el-empty description="出错了，请关闭后再打开"></el-empty>
    </div>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped lang="sass">
</style>